module.exports = __webpack_public_path__ + "static/teck_3-88143bf7883c2ac4252d8cdbcb7f5abd.jpg";